import {Card} from 'antd';
import cn from 'classnames';
import React, {
    useEffect, useMemo, useState, FC,
} from 'react';
import {useDispatch} from 'react-redux';

import {Spinner} from 'components/spinner';
import {loadMetadata, selectMetadata} from 'entities/metadata';
import {selectDashboardEntityData} from 'modules/data/data-selectors';
import {EEntityType} from 'shared/constants/entities';
import {useAppSelector} from 'store/config/hooks';
import {selectMenuStructure} from 'store/slices/menu-slice';

import {DictionaryLayoutRow} from '../components/dictionaries-layout-row';
import {WidgetLayoutRow} from '../components/widget-layout-row';
import {MainPageSectionTitle} from './main-page-section-title/main-page-section-title';
import s from './main-widget-page.module.less';
import {mapDirectionLayout, mapWidgetsLayout} from './main-widget-page.utils';


interface IMainWidgetPageProps {
    entityName: string;
}

export const MainWidgetPage: FC<IMainWidgetPageProps> = ({entityName}: IMainWidgetPageProps) => {
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const menuStructure = useAppSelector(selectMenuStructure);
    const metadata = useAppSelector(selectMetadata(entityName, EEntityType.WIDGETS));
    const dashboardData = useAppSelector(selectDashboardEntityData(entityName));

    const directoriesLayout = useMemo(() => mapDirectionLayout(metadata?.widgetsConfig?.dictionariesLayout, menuStructure),
        [metadata?.widgetsConfig?.dictionariesLayout, menuStructure]);

    const widgetsLayout = useMemo(() => mapWidgetsLayout(metadata?.widgetsConfig?.widgetsLayout, menuStructure),
        [metadata?.widgetsConfig?.widgetsLayout, menuStructure]);

    useEffect(() => {
        (async () => {
            if (!metadata) {
                setIsLoading(true);
                dispatch(loadMetadata(entityName, EEntityType.WIDGETS));
                setIsLoading(false);
            }
        })();
    });

    return (
        <div className={cn(s.mainWidgetPage)}>
            {!isLoading ? (
                <Card>
                    {metadata?.widgetsConfig?.widgetsTitle && (<MainPageSectionTitle title={metadata?.widgetsConfig?.widgetsTitle} />)}
                    {widgetsLayout?.map(widgetLayout => (
                        <WidgetLayoutRow
                            widgetLayout={widgetLayout}
                            fields={metadata?.fields}
                            data={dashboardData}
                            entityName={entityName}
                        />
                    ))}
                    {metadata?.widgetsConfig?.dictionariesTitle
                        && (<MainPageSectionTitle title={metadata?.widgetsConfig?.dictionariesTitle} />)}
                    {directoriesLayout?.map(dictionaryLayout => (
                        <DictionaryLayoutRow
                            dictionaryLayout={dictionaryLayout}
                        />
                    ))}
                </Card>
            ) : (
                <div className={s.mainWidgetPageSpinner}>
                    <Spinner />
                </div>
            )}
        </div>
    );
};

